import {
  DebtsAlertBanner,
  DebtsAlertModal,
  DeviceProfileModal,
  DevicesAnalysisViewModal,
  UserPreferencesModal,
  UserProfileModal,
  UserProfileUpdateModal,
} from '@/features/';
import useAuth from '@/hooks/useAuth';
import useGlobalShortcuts from '@/hooks/useGlobalShortcuts';
import { useI18n } from '@/hooks/useI18n';
import { DeviceUserAccessGlobalModals } from '@features/access';
import AnnouncementsViewModal from '@features/announcements/components/AnnouncementsViewModal';
import { useAuthorizationRefetch } from '@features/authorization';
import UpdateDeviceAlertsModal from '@features/createDeviceAlerts/components/CreateDeviceAlerts';
import SaveHardwareConfigurationModal from '@features/createDeviceConfiguration/components/SaveHardwareConfiguration';
import { DeviceConfigurationGlobalModals } from '@features/deviceConfigurationModal';
import DeviceDataConfigurationModal from '@features/deviceDataConfigurationModal';
import { DeviceObservationsModals } from '@features/deviceObservations';
import DGAModals from '@features/dga/components/modals/DGAModals';
import { useGatesMovementGlobalActions } from '@features/gateAdministration/hooks/useGatesMovementGlobalActions';
import { GroupedIssuesModal } from '@features/integrations';
import { SmaSuccessTableModal, SmaUpsertModal } from '@features/sma';
import SMAReportsTableModal from '@features/sma/components/TableModal';
import { SaveUserModalGlobal } from '@features/userSaveModal';
import DeleteUserModal from '@features/users/components/modals/DeleteUserModal';
import ExtendTemporaryUserModal from '@features/users/components/modals/ExtendTemporaryUserModal';
import ExtendTemporaryUserTokenModal from '@features/users/components/modals/ExtendTemporaryUserTokenModal';
import SimulateUserModal from '@features/users/components/modals/SimulateUserModal';
import SimulateUserShortcutModal from '@features/users/components/modals/SimulateUserShortcutModal';
import PicturePreview from './PicturePreview';
import GlobalSnackbar from './Snackbar';
import CreateMeasurementAdapterModal from './optionsMenu/dialogs/CreateMeasurementAdapterModal';
import ManualDataDetailsAdapterModal from './optionsMenu/dialogs/ManualDataDetailsAdapterModal';
import { DeviceAlertsModal } from '@features/deviceAlertsModal';
import { DevicesGraveyard } from '@features/devicesGraveyard';
import { UsersGraveyard } from '@features/usersGraveyard';
import { DisableAlertsModal } from '@features/deviceAlertsModal/components/disableAlertsModal';
import { Confetti } from './Confetti';
import { RawDataModal } from '@features/deviceAlertsModal/components/rawDataModal';
import { UserConfigurationModal } from '@features/userConfigurationModal';
import { DeviceAccessModal } from '@features/deviceAccessModal';
import { CreateDeviceModal } from '@features/createDevice';
import { DownloadDataModal } from '@features/downloadData/components/DownloadDataModal';
import { ReportProblemModal } from '@features/reportProblem';
import { OrganizationPreferencesModal } from '@features/organizationPreferences';
import { DgaTicketModal } from '@features/dgaTicket';
import { CreateReportModalRouter } from '@features/reports2/components/createModal/CreateReportModalRouter';
import { AlertsConfigurationModal } from '@features/alertsConfigurationV2/components/upsertModal/AlertsConfigurationModal';
import { UserActivityLogsModal } from '@features/userActivityLogs';
import { MoveGateModal } from '@features/moveGateModal';
import { GateOperationModal } from '@features/gateOperationModal';
import { ActiveGateDataRefresher } from '@features/gateCommon/components/ActiveGateDataRefresher';
import { GateMessagesSubscription } from '@features/gateCommon/components/GateMessagesSubscription';
import { AfterUpdateTasksModal } from '@features/changeOperationalState/components/AfterUpdateTasksModal';
import { GateMovementsHistoryModal } from '@features/gateCommon/components/historyModal';
import { UpdateMultipleDevicesTagsModal } from '@features/updateMultipleDevicesTags';
import { ResendCredentialsModal } from '@features/resendCredentialsModal';
import { TriggerConfigUpdateModal, ConfigurationFileHistoryModal } from '@features/deviceConfiguration/components';

const LoggedInGlobalComponents = () => {
  useGatesMovementGlobalActions();
  useI18n();
  useAuthorizationRefetch();
  useGlobalShortcuts();

  return (
    <>
      {/* Place for global components that needs auth */}
      <UserPreferencesModal />
      <UserProfileModal />
      <UserProfileUpdateModal />
      <SimulateUserModal />
      <SimulateUserShortcutModal />
      <DeleteUserModal />
      <SaveUserModalGlobal />
      <PicturePreview />
      <DebtsAlertModal />
      <DebtsAlertBanner />
      <AnnouncementsViewModal />
      <DevicesAnalysisViewModal />
      <DeviceProfileModal />
      <DeviceConfigurationGlobalModals />
      <DeviceDataConfigurationModal />
      <DGAModals />
      <UpdateDeviceAlertsModal />
      <AlertsConfigurationModal />
      <DeviceObservationsModals />
      <CreateMeasurementAdapterModal />
      <ManualDataDetailsAdapterModal />
      <SmaUpsertModal />
      <SmaSuccessTableModal />
      <SMAReportsTableModal />
      <ExtendTemporaryUserModal />
      <ExtendTemporaryUserTokenModal />
      <SaveHardwareConfigurationModal />
      <DeviceUserAccessGlobalModals />
      <DevicesGraveyard />
      <UsersGraveyard />
      <GroupedIssuesModal />
      <DeviceAlertsModal />
      <DisableAlertsModal />
      <RawDataModal />
      <UserConfigurationModal />
      <DeviceAccessModal />
      <CreateDeviceModal />
      <DownloadDataModal />
      <ReportProblemModal />
      <OrganizationPreferencesModal />
      <DgaTicketModal />
      <CreateReportModalRouter />
      <UserActivityLogsModal />
      <MoveGateModal />
      <GateOperationModal />
      <GateMessagesSubscription />
      <ActiveGateDataRefresher />
      <AfterUpdateTasksModal />
      <GateMovementsHistoryModal />
      <UpdateMultipleDevicesTagsModal />
      <ResendCredentialsModal />
      <TriggerConfigUpdateModal />
      <ConfigurationFileHistoryModal />
    </>
  );
};

const GlobalComponents = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {/* No auth needed global components */}
      <GlobalSnackbar />
      <Confetti />
      {isAuthenticated && <LoggedInGlobalComponents />}
    </>
  );
};

export default GlobalComponents;
